import React, { useState } from "react";
import { Box, useColorMode } from "@chakra-ui/react";

interface ThemeAwareLogoProps {
  alt?: string;
  height?: string | number;
  width?: string | number;
}

const ThemeAwareLogo: React.FC<ThemeAwareLogoProps> = ({
  alt = "LearnYourself Logo",
  height = 50,
  width = "auto",
}) => {
  const { colorMode } = useColorMode();
  const [imageError, setImageError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  
  // Use white logo for dark mode and regular logo for light mode
  const logoSrc = colorMode === "dark" 
    ? "/logos/LearnYourselfHomepageLogo_white.png" 
    : "/logos/LearnYourselfHomepageLogo.png";
  
  // Log for debugging
  React.useEffect(() => {
    console.log("Logo path:", logoSrc);
    console.log("Color mode:", colorMode);
    setImageError(false);
    setIsLoading(false);
  }, [logoSrc, colorMode]);
  
  if (imageError) {
    return (
      <Box
        display="inline-flex"
        alignItems="center"
        justifyContent="center"
        height={height}
        px={3}
        py={1}
        bg={colorMode === "dark" ? "gray.700" : "gray.200"}
        borderRadius="md"
        fontWeight="bold"
        fontSize="xl"
        color={colorMode === "dark" ? "white" : "gray.800"}
      >
        LearnYourself
      </Box>
    );
  }
  
  return (
    <>
      {isLoading && !imageError && (
        <Box
          height={height}
          width={typeof width === 'number' ? width : height}
          bg="transparent"
          borderRadius="md"
        />
      )}
      <img
        src={logoSrc}
        alt={alt}
        height={height}
        width={width}
        style={{
          display: isLoading ? "none" : "block",
          objectFit: "contain",
          transition: "transform 0.2s",
        }}
        onLoad={() => {
          setIsLoading(false);
        }}
        onMouseOver={(e) => {
          (e.target as HTMLImageElement).style.transform = "scale(1.05)";
        }}
        onMouseOut={(e) => {
          (e.target as HTMLImageElement).style.transform = "scale(1)";
        }}
        onError={(e) => {
          console.error("Logo failed to load:", logoSrc);
          console.error("Error event:", e);
          setImageError(true);
          setIsLoading(false);
        }}
      />
    </>
  );
};

export default ThemeAwareLogo;